import gql from 'graphql-tag';

const UPDATE_VENDOR = gql`
  mutation Mutation($deviceSerialNo: String!, $vendor: String!) {
    updateVendor(deviceSerialNo: $deviceSerialNo, vendor: $vendor) {
      code
    }
  }
`;

export default UPDATE_VENDOR;
